/**
 * INIT
 * initialize project js
 */

// import dependencies
let promise = require('es6-promise'); promise.polyfill();
let app = require('./_init-app');

if (window.jQuery) { if (!window.$) { window.$ = window.jQuery; } app.__imported.push('jquery'); }

app.breakpoint = 768;
app.pathPrepend = '/wp-content/themes/project/';
app.timeoutInterval = 200;

// add webcomponents
app.registerWebcomponent('google-map', app.path('bower_components/google-map/google-map.html'));


// accordion
app.register('load', () => {
    app.el('dl.accordion dt a[role="button"]').listen('click', (e, el) => {
        el = app.el(el);
        if (el.getAttribute('aria-expanded') == 'true') {
            el.setAttribute('aria-expanded', 'false');
            el.parent.next.setAttribute('aria-hidden', 'true');
            app.animate(el.parent.next, 'slideUp');
        } else {
            el.setAttribute('aria-expanded', 'true');
            el.parent.next.setAttribute('aria-hidden', 'false');
            app.animate(el.parent.next, 'slideDown');
            
        }
    });
});

// sliders
app.register('load', () => {
    if (app.exists('.the-gallery-slider')) {
        if (window.location.href.indexOf('#') >= 0) { 
            let currentID = window.location.href.split('#')[1];
            let mainSlide = app.el(`.the-gallery-slider #${currentID}`);
            let whichSlide = 0;
            let whichSlideCounter = 0;
            mainSlide.parent.children.forEach(e => {
                whichSlideCounter++;
                if (e.node === mainSlide.node) { 
                    whichSlide = whichSlideCounter;
                }
            });
            app.el('.the-gallery-slider .slider').setAttribute('data-slick-initial-slide', whichSlide - 1);
            whichSlide = Math.ceil(whichSlide / 8);
            app.el('.gallery-page .block.gallery [data-slick-slider]').setAttribute('data-slick-initial-slide', whichSlide - 1);
        }
        Promise.all([
            app.import('imagesloaded'),
            app.import('slick')
        ]).then(() => {
            let slider = app.el('.the-gallery-slider .slider');
            imagesLoaded(slider.node).on('done', function () {
                $(slider.node).on('init', function (slick) {
                    let currentID = $('.the-gallery-slider .slider .slick-active').attr('id');
                    $(`.gallery-page .block.gallery [data-slick-slider] a[data-slide-id="${currentID}"]`).addClass('active');
                });
                $(slider.node).slick({
                    adaptiveHeight: true,
                    arrows: true,
                    dots: false,
                    initialSlide: (slider.getAttribute('data-slick-initial-slide')) ? parseInt(slider.getAttribute('data-slick-initial-slide')) : 0
                });
                $(slider.node).on('beforeChange', function (slick, el, currentSlide, nextSlide) {
                    upcomingSlide = Math.ceil((nextSlide + 1) / 8);
                    $('.gallery-page .block.gallery [data-slick-slider]').slick('slickGoTo', upcomingSlide - 1);
                });
                $(slider.node).on('afterChange', function (slick, el, nextSlide) { 
                    let currentID = $('.the-gallery-slider .slider .slick-active').attr('id');
                    let url = window.location.href.split('#')[0] + '#' + currentID;
                    $('.gallery-page .block.gallery [data-slick-slider] a').removeClass('active');
                    $(`.gallery-page .block.gallery [data-slick-slider] a[data-slide-id="${currentID}"]`).addClass('active');
                    window.history.pushState({ href: url }, '', url);
                });
                $('.gallery-page .block.gallery [data-slick-slider] a').click(function (e) {
                    e.preventDefault();
                    $('.gallery-page .block.gallery [data-slick-slider] a').removeClass('active');
                    $(this).addClass('active');
                    let goTo = parseInt($(this).attr('data-gallery-i')) - 1;
                    $(slider.node).slick('slickGoTo', goTo);
                    $('html, body').animate({
                        scrollTop: $("#" + $(this).attr('data-slide-id')).offset().top
                    }, 200);
                });
            });
        });
    }
    if (app.exists('[data-slick-slider]')) {
        Promise.all([
            app.import('imagesloaded'),
            app.import('slick')
        ]).then(() => {
            app.el('[data-slick-slider]').forEach(el => {
                let options = {
                    adaptiveHeight: (el.getAttribute('data-slick-adaptive-height') === '' || el.getAttribute('data-slick-adaptive-height') === 'true') ? true : false,
                    arrows: (el.getAttribute('data-slick-arrows') && el.getAttribute('data-slick-arrows') === 'false') ? false : true,
                    asNavFor: (el.getAttribute('data-slick-as-nav-for')) ? el.getAttribute('data-slick-as-nav-for') : false,
                    autoplay: (el.getAttribute('data-slick-autoplay') === '' || el.getAttribute('data-slick-autoplay') === 'true') ? true : false,
                    autoplaySpeed: (el.getAttribute('data-slick-autoplay-speed')) ? parseFloat(el.getAttribute('data-slick-autoplay-speed')) : 3000,
                    centerMode: (el.getAttribute('data-slick-center-mode') === '' || el.getAttribute('data-slick-center-mode') === 'true') ? true : false,
                    centerPadding: (el.getAttribute('data-slick-center-padding')) ? el.getAttribute('data-slick-center-padding') : '50px',
                    cssEase: (el.getAttribute('data-slick-css-ease')) ? el.getAttribute('data-slick-css-ease') : 'cubic-bezier(.55, 0, .1, 1)',
                    draggable: (el.getAttribute('data-slick-draggable') && el.getAttribute('data-slick-draggable') === 'false') ? false : true,
                    dots: (el.getAttribute('data-slick-dots') === '' || el.getAttribute('data-slick-dots') === 'true') ? true : false,
                    easing: (el.getAttribute('data-slick-easing')) ? el.getAttribute('data-slick-easing') : 'linear',
                    edgeFriction: (el.getAttribute('data-slick-edge-friction')) ? parseFloat(el.getAttribute('data-slick-edge-friction')) : 0.15,
                    fade: (el.getAttribute('data-slick-fade') === '' || el.getAttribute('data-slick-fade') === 'true') ? true : false,
                    focusOnSelect: (el.getAttribute('data-slick-focus-on-select') === '' || el.getAttribute('data-slick-focus-on-select') === 'true') ? true : false,
                    infinite: (el.getAttribute('data-slick-infinite') && el.getAttribute('data-slick-infinite') === 'false')? false : true,
                    initialSlide: (el.getAttribute('data-slick-initial-slide')) ? parseInt(el.getAttribute('data-slick-initial-slide')) : 0,
                    respondTo: (el.getAttribute('data-slick-respond-to')) ? el.getAttribute('data-slick-respond-to') : 'window',
                    responsive: (el.getAttribute('data-slick-responsive')) ? app.textToData(el.getAttribute('data-slick-responsive')) : null,
                    rows: (el.getAttribute('data-slick-rows')) ? parseInt(el.getAttribute('data-slick-rows')) : 1,
                    slidesPerRow: (el.getAttribute('data-slick-slides-per-row')) ? parseInt(el.getAttribute('data-slick-slides-per-row')) : 1,
                    slidesToShow: (el.getAttribute('data-slick-slides-to-show')) ? parseInt(el.getAttribute('data-slick-slides-to-show')) : 1,
                    slidesToScroll: (el.getAttribute('data-slick-slides-to-scroll')) ? parseInt(el.getAttribute('data-slick-slides-to-scroll')) : 1,
                    speed: (el.getAttribute('data-slick-speed')) ? parseInt(el.getAttribute('data-slick-speed')) : 300,
                    swipe: (el.getAttribute('data-slick-swipe') && el.getAttribute('data-slick-swipe') === 'false') ? false : true,
                    swipeToSlide: (el.getAttribute('data-slick-swipe-to-slide') === '' || el.getAttribute('data-slick-swipe-to-slide') === 'true') ? true : false,
                    touchMove: (el.getAttribute('data-slick-touch-move') && el.getAttribute('data-slick-touch-move') === 'false') ? false : true,
                    touchThreshold: (el.getAttribute('data-slick-touch-threshold')) ? parseInt(el.getAttribute('data-slick-touch-threshold')) : 5,
                    variableWidth: (el.getAttribute('data-slick-variable-width') === '' || el.getAttribute('data-slick-variable-width') === 'true') ? true : false,
                    vertical: (el.getAttribute('data-slick-vertical') === '' && el.getAttribute('data-slick-vertical') === 'true') ? true : false,
                    verticalSwiping: (el.getAttribute('data-slick-vertical-swiping')) ? el.getAttribute('data-slick-vertical-swiping') : false
                }
                imagesLoaded(el.node).on('done', function () {
                    $(el.node).slick(options);
                });
            });
        });    
    }
});

// breadcrumbs sticky
app.register(['load', 'resize'], () => { 
    app.import('scrollmagic').then(() => {
        app.scrollMagic = new ScrollMagic.Controller();
        if (app.scrollScene) { app.scrollScene.destroy(); }
        let offset = (app.width > 1023) ? 170 : 355;
        app.scrollScene = new ScrollMagic.Scene({ offset: offset })
            .setClassToggle('body', 'breadcrumbs-scrolledpast')
            .addTo(app.scrollMagic);
    });
});

// main menu control
app.register('load', () => {
    app.import('velocity').then(() => {
        app.el('.menu-control').listen('click', () => {
            app.el('header').toggleClass('menu-open');
            if (app.el('header').hasClass('menu-open')) {
                app.animate(app.el('.main-menu'), 'slideDown', () => { app.el('.main-menu').setAttribute('style', ''); });
            } else {
                app.el('.main-menu').setAttribute('style', 'display: block');
                app.animate(app.el('.main-menu'), 'slideUp', () => { app.el('.main-menu').setAttribute('style', ''); });
            }
        });
        app.el('.find-us-control').listen('click', () => {
            app.el('header').toggleClass('find-us-open');
            if (app.el('header').hasClass('find-us-open')) {
                app.animate(app.el('.find-us-popover'), 'slideDown', () => { app.el('.find-us-popover').setAttribute('style', ''); });
            } else {
                app.el('.find-us-popover').setAttribute('style', 'display: block');
                app.animate(app.el('.find-us-popover'), 'slideUp', () => { app.el('.find-us-popover').setAttribute('style', ''); });
            }
            document.querySelector('google-map').resize();
        });
        app.el('.find-us-popover .close').listen('click', () => {
            app.el('header').removeClass('find-us-open');
            app.el('.find-us-popover').setAttribute('style', 'display: block');
            app.animate(app.el('.find-us-popover'), 'slideUp', () => { app.el('.find-us-popover').setAttribute('style', ''); });
            document.querySelector('google-map').resize();
        });
        app.el('.menu .close').listen('click', () => {
            app.el('header').removeClass('menu-open');
            app.el('.menu').setAttribute('style', 'display: block');
            app.animate(app.el('.menu'), 'slideUp', () => { app.el('.menu').setAttribute('style', ''); });
        });
    });
});

// run app
app.run();



// WEBPACK FOOTER //
// ./es6/app.js